import _regeneratorRuntime from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { getMimeType } from './mimes';
import { resourceToDataURL } from './dataurl';
import { clonePseudoElements } from './clone-pseudos';
import { createImage, toArray } from './util';

function cloneCanvasElement(_x) {
  return _cloneCanvasElement.apply(this, arguments);
}

function _cloneCanvasElement() {
  _cloneCanvasElement = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(canvas) {
    var dataURL;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dataURL = canvas.toDataURL();

            if (!(dataURL === 'data:,')) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", canvas.cloneNode(false));

          case 3:
            return _context.abrupt("return", createImage(dataURL));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _cloneCanvasElement.apply(this, arguments);
}

function cloneVideoElement(_x2, _x3) {
  return _cloneVideoElement.apply(this, arguments);
}

function _cloneVideoElement() {
  _cloneVideoElement = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(video, options) {
    var poster, contentType, dataURL;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            poster = video.poster;
            contentType = getMimeType(poster);
            _context2.next = 4;
            return resourceToDataURL(poster, contentType, options);

          case 4:
            dataURL = _context2.sent;
            return _context2.abrupt("return", createImage(dataURL));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _cloneVideoElement.apply(this, arguments);
}

function cloneSingleNode(_x4, _x5) {
  return _cloneSingleNode.apply(this, arguments);
}

function _cloneSingleNode() {
  _cloneSingleNode = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(node, options) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(node instanceof HTMLCanvasElement)) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", cloneCanvasElement(node));

          case 2:
            if (!(node instanceof HTMLVideoElement && node.poster)) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt("return", cloneVideoElement(node, options));

          case 4:
            return _context3.abrupt("return", node.cloneNode(false));

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _cloneSingleNode.apply(this, arguments);
}

var isSlotElement = function isSlotElement(node) {
  return node.tagName != null && node.tagName.toUpperCase() === 'SLOT';
};

function cloneChildren(_x6, _x7, _x8) {
  return _cloneChildren.apply(this, arguments);
}

function _cloneChildren() {
  _cloneChildren = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(nativeNode, clonedNode, options) {
    var _a, children;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            children = isSlotElement(nativeNode) && nativeNode.assignedNodes ? toArray(nativeNode.assignedNodes()) : toArray(((_a = nativeNode.shadowRoot) !== null && _a !== void 0 ? _a : nativeNode).childNodes);

            if (!(children.length === 0 || nativeNode instanceof HTMLVideoElement)) {
              _context4.next = 3;
              break;
            }

            return _context4.abrupt("return", clonedNode);

          case 3:
            _context4.next = 5;
            return children.reduce(function (deferred, child) {
              return deferred.then(function () {
                return cloneNode(child, options);
              }).then(function (clonedChild) {
                if (clonedChild) {
                  clonedNode.appendChild(clonedChild);
                }
              });
            }, Promise.resolve());

          case 5:
            return _context4.abrupt("return", clonedNode);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _cloneChildren.apply(this, arguments);
}

function cloneCSSStyle(nativeNode, clonedNode) {
  var targetStyle = clonedNode.style;

  if (!targetStyle) {
    return;
  }

  var sourceStyle = window.getComputedStyle(nativeNode);

  if (sourceStyle.cssText) {
    targetStyle.cssText = sourceStyle.cssText;
    targetStyle.transformOrigin = sourceStyle.transformOrigin;
  } else {
    toArray(sourceStyle).forEach(function (name) {
      var value = sourceStyle.getPropertyValue(name);

      if (name === 'font-size' && value.endsWith('px')) {
        var reducedFont = Math.floor(parseFloat(value.substring(0, value.length - 2))) - 0.1;
        value = "".concat(reducedFont, "px");
      }

      targetStyle.setProperty(name, value, sourceStyle.getPropertyPriority(name));
    });
  }
}

function cloneInputValue(nativeNode, clonedNode) {
  if (nativeNode instanceof HTMLTextAreaElement) {
    clonedNode.innerHTML = nativeNode.value;
  }

  if (nativeNode instanceof HTMLInputElement) {
    clonedNode.setAttribute('value', nativeNode.value);
  }
}

function cloneSelectValue(nativeNode, clonedNode) {
  if (nativeNode instanceof HTMLSelectElement) {
    var clonedSelect = clonedNode;
    var selectedOption = Array.from(clonedSelect.children).find(function (child) {
      return nativeNode.value === child.getAttribute('value');
    });

    if (selectedOption) {
      selectedOption.setAttribute('selected', '');
    }
  }
}

function decorate(nativeNode, clonedNode) {
  if (clonedNode instanceof Element) {
    cloneCSSStyle(nativeNode, clonedNode);
    clonePseudoElements(nativeNode, clonedNode);
    cloneInputValue(nativeNode, clonedNode);
    cloneSelectValue(nativeNode, clonedNode);
  }

  return clonedNode;
}

export function cloneNode(_x9, _x10, _x11) {
  return _cloneNode.apply(this, arguments);
}

function _cloneNode() {
  _cloneNode = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(node, options, isRoot) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(!isRoot && options.filter && !options.filter(node))) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return", null);

          case 2:
            return _context5.abrupt("return", Promise.resolve(node).then(function (clonedNode) {
              return cloneSingleNode(clonedNode, options);
            }).then(function (clonedNode) {
              return cloneChildren(node, clonedNode, options);
            }).then(function (clonedNode) {
              return decorate(node, clonedNode);
            }));

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _cloneNode.apply(this, arguments);
}